"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _userflow = _interopRequireDefault(require("../../../styles/userflow"));
var _Check = _interopRequireDefault(require("../../../icons-react/Check"));
var Option = function Option(props) {
  var innerProps = props.innerProps,
    isSelected = props.isSelected,
    innerRef = props.innerRef,
    isFocused = props.isFocused,
    data = props.data;
  var value = data.value,
    label = data.label;
  return /*#__PURE__*/_react["default"].createElement(StyledDeparture, (0, _extends2["default"])({
    ref: innerRef
  }, innerProps, {
    isFocused: isFocused,
    notFound: value === ''
  }), label, isSelected && /*#__PURE__*/_react["default"].createElement(StyledIconCheck, null));
};
var StyledDeparture = _styledComponents["default"].div.withConfig({
  displayName: "Option__StyledDeparture",
  componentId: "sc-ot1zia-0"
})(["display:flex;align-items:center;padding:0 8px;border-top:1px solid ", ";width:100%;height:48px;font-size:14px;line-height:16px;font-weight:normal;background-color:", ";&:hover{cursor:pointer;background-color:", ";}&:first-child{border-top:none;}", ""], _userflow["default"].colors.whiteLight, function (_ref) {
  var isFocused = _ref.isFocused;
  return isFocused && _userflow["default"].colors.solitude;
}, _userflow["default"].colors.solitude, function (_ref2) {
  var notFound = _ref2.notFound;
  return notFound && 'text-align: center; color: grey;';
});
var StyledIconCheck = (0, _styledComponents["default"])(_Check["default"]).withConfig({
  displayName: "Option__StyledIconCheck",
  componentId: "sc-ot1zia-1"
})(["width:14px;height:10px;margin-left:auto;margin-right:10px;stroke:", ";"], _userflow["default"].colors.blackBase);
var _default = exports["default"] = Option;